import axios from "axios";
import config from "./config";

axios.defaults.transformRequest = [
  function (data, headers) {
    if (headers["Content-Type"] === "application/json") {
      return JSON.stringify(data);
    }

    if (data instanceof FormData) {
      return data;
    }
    let ret = "";
    for (const it in data) {
      ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
    }
    return ret;
  },
];

let baseUrl = config.baseUrl;
// 创建 axios 实例，设置基础地址和超时时间
const http = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
});

const err = (error) => {
  return Promise.reject(error);
};

//实例的请求拦截器
http.interceptors.request.use((config) => {
  // const token = localDb.get("token");
  // if (token) {
  //   config.headers["token"] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
  // }
  return config;
}, err);

let SUCCESS = 200;
let lock = false;
http.interceptors.response.use((response) => {
  const files = ["application/octet-stream", "application/zip"];
  if (files.includes(response.headers["content-type"])) {
    return response;
  }
  let res = response.data;

  if (res == null || res.code == null) {
    return res;
  }

  //默认success为false
  res.success = false;
  //如果code==2 说明token失效 跳转到登录页面
  // if (res.code === 2) {
  //   if (lock) {
  //     return res;
  //   }
  //   lock = true;
  //   let id = null;
  //   //提示token失效
  //   let md = modal.warning({
  //     title: "温馨提示",
  //     content: "登录状态已失效!\n即将跳转到登陆页面！",
  //     okText: "立即跳转",
  //     onOk: () => {
  //       lock = false;
  //       clearTimeout(id);
  //       router.push({ name: "Login" });
  //     },
  //   });
  //   id = setTimeout(function () {
  //     lock = false;
  //     router.push({ name: "Login" });
  //     md.destroy();
  //   }, 5000);
  //   return res;
  // }
  if (res.code === SUCCESS) {
    res.success = true;
  }
  if (config.baseUrl === "http://www.timesnew.cn:8181") {
    let jsonStr = JSON.stringify(res.data)
    let newStr = jsonStr.replaceAll(
      "http://172.16.10.217:8181",
      "http://www.timesnew.cn:8181"
    )
    let newJson = JSON.parse(newStr)
    res.data = newJson
  }
  return res;
}, err);

function upload(url, data) {
  return http({
    url: url,
    method: "post",
    timeout: 0,
    data,
    transformRequest: [
      function (data, headers) {
        delete headers.post["Content-Type"];
        return data;
      },
    ],
  });
}

function get(url, data = {}) {
  return http.get(url, {
    params: data,
  });
}

//默认采用json数据格式提交，传入true时是form-data方式提交
function post(url, data = {}, isForm = false, timeout = 30000) {
  return http({
    url: url,
    method: "post",
    data,
    timeout: timeout,
    headers: {
      "Content-Type": isForm
        ? "application/x-www-form-urlencoded"
        : "application/json",
    },
  });
}
function download(url, data, fileName) {
  return http({
    url: url,
    method: "post",
    timeout: 0,
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => {
    let url = window.URL.createObjectURL(new Blob([res.data]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}
//导出工具
export function exportUtil(res, fileName) {
  let resData = res.data || res;
  let index = fileName.lastIndexOf(".");
  let fileNameSuffix = fileName.substring(index + 1, fileName.length);
  let typeUrl = "";
  if (fileNameSuffix == "doc") {
    typeUrl =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8";
  } else if (fileNameSuffix === "zip") {
    typeUrl = "application/zip;charset=utf-8";
  } else {
    typeUrl = "application/octet-stream;charset=utf-8";
  }
  const blob = new Blob([resData], {
    // type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'//word
    type: typeUrl,
  });
  if ("download" in document.createElement("a")) {
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob);
  }
}
export function uploadFile(data, path = null) {
  return http({
    url: path ? path : "/common/uploadFile",
    method: "post",
    data,
    headers: {
      "Content-Type": "multiple/form-data",
    },
  });
}

//导出
export function exportPartData(data, url, type = false) {
  return http({
    url,
    method: "post",
    responseType: "blob",
    timeout: 0,
    headers: {
      "Content-Type": type
        ? "application/x-www-form-urlencoded"
        : "application/json",
    },
    data,
  });
}

export default {
  get,
  post,
  download,
  upload,
  exportPartData,
  exportUtil,
};
